import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Container, Row } from 'react-bootstrap';
import Button from '../Button';
import IconButton from '../IconButton';
import ContactCard from './ContactCard';

const contactButtons = [
  <IconButton variant="secondary-shadow" icon={light('phone')} disabled />,

  <IconButton variant="secondary-shadow" icon={light('globe')} disabled />,

  <IconButton variant="secondary-shadow" icon={light('file-pdf')} disabled />,
];

const ContactCardDemo = () => {
  return (
    <Container>
      <Container className="mt-10">
        <h4>Contact Card</h4>
        <Row className={'mx-0 row-cols-3'}>
          <Container
            className={'pb-10 px-0 w-100'}
            style={{ maxWidth: '253px' }}
          >
            <ContactCard
              titleIcon={light('heart-pulse')}
              title={'Medical'}
              img={`${process.env.PUBLIC_URL}/${'cigna.png'}`}
              medicalGroup={'Cigna HMO'}
              status={'enrolled'}
              statusIcon={light('circle-check')}
              contactButtons={contactButtons}
              button={
                <Button className={'col-12 mt-7'} variant="primary" size="lg">
                  View All
                </Button>
              }
            />
          </Container>

          <Container
            className={'pb-10 px-0 w-100'}
            style={{ maxWidth: '253px' }}
          >
            <ContactCard
              titleIcon={light('heart-pulse')}
              title={'Medical'}
              img={`${process.env.PUBLIC_URL}/${'cigna.png'}`}
              medicalGroup={'Cigna HMO'}
              status={'enrolled'}
              statusIcon={light('circle-check')}
              contactButtons={contactButtons}
            />
          </Container>
          <Container
            className={'pb-10 px-0 w-100'}
            style={{ maxWidth: '253px' }}
          >
            <ContactCard
              bg={'transperant-with-border'}
              titleIcon={light('heart-pulse')}
              title={'Medical'}
              img={`${process.env.PUBLIC_URL}/${'cigna.png'}`}
              medicalGroup={'Cigna HMO'}
              status={'enrolled'}
              statusIcon={light('circle-check')}
              contactButtons={contactButtons}
            />
          </Container>
          <Container
            className={'pb-10 px-0 w-100'}
            style={{ maxWidth: '253px' }}
          >
            <ContactCard
              title={'Medical'}
              button={
                <Button className={'col-12 mt-7'} variant="primary" size="lg">
                  View All
                </Button>
              }
            />
          </Container>
        </Row>
      </Container>
    </Container>
  );
};

export default ContactCardDemo;
